export default "__VITE_ASSET__DGyK9m28__"